<div class="d-flex justify-content-center align-items-center vh-100">
  <div class="main p-4 rounded border border-secondary text-light">

    <div class="form-signin w-100 m-auto">
      <div>
        <h1 class="h3 mb-3 fw-normal">Woodpecker Method</h1>
        <button (click)="loginWithGoogle()" class="btn btn-primary d-flex align-items-center px-3 py-2 w-100">
          <img src="https://www.gstatic.com/firebasejs/ui/2.0.0/images/auth/google.svg"
               alt="Google logo"
               width="20px"
               height="20px">
          <span class="flex-grow-1 text-center">Sign in with Google</span>
        </button>

        @if (error) {
          <p style="color:red;">{{ error }}</p>
        }
      </div>
    </div>

  </div>
</div>
